import styled from "styled-components";
import {useTranslation} from "react-i18next";
import useTitleAndDescription from "../../common/hooks/useTitleAndDescription";
import {Footer, Header, Loading} from "../common";
import {ErrorBoundary} from "react-error-boundary";
import CenterContentBox from "../Champions/ContentWrapper";
import React, {Suspense} from "react";
import BottomStickAd from "../ad/BottomStickAd";
import MangContent from "./MangContent";

const Wrapper = styled.div`
`;

const ContentWrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;


function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}

const Mang = () => {
    const {t} = useTranslation();
    useTitleAndDescription({
        title: '2026 결망전 스크림  | DEEPLOL.GG',
        description: '딥롤이 후원한 결망전 3회차의 결과를 확인해 보세요.',
    })
    return (
        <Wrapper>
            <Header/>
            <ContentWrapper>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <CenterContentBox disableSponsor={true}>
                        <Suspense fallback={<Loading/>}>
                            <MangContent/>
                        </Suspense>
                    </CenterContentBox>
                </ErrorBoundary>
            </ContentWrapper>
            <Footer/>
            <BottomStickAd/>
        </Wrapper>
    );
};


export default Mang